import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  FlexBetween,
  FlexColumn,
} from "../../../../styles/styled-components-utils";
import { setAlert } from "../../../../actions/alert";
import {
  clearSuggestions,
  updateRestaurant,
} from "../../../../actions/restaurantBuilder";
import {
  getCreationEventContext,
  clearCreationEventContext,
} from "../../../../util/creationEventContext";
import RestaurantEditForm from "./RestaurantEditForm";

export const SpaceApartDiv = styled(FlexBetween)`
  flex-wrap: wrap;
`;

export const LeftDiv = styled(FlexColumn)`
  justify-content: flex-end;
  width: 100%;
`;

const RestaurantCreateBuild = ({
  currRestaurant,
  setAlert,
  updateRestaurant,
  clearSuggestions,
}) => {
  const navigate = useNavigate();

  const createRestaurant = async (restaurant) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const eventCtx = getCreationEventContext();
    const body = JSON.stringify({
      ...restaurant,
      ...(eventCtx?.eventId && { eventId: eventCtx.eventId, eventOnly: true }),
    });
    try {
      const response = await axios.post("/api/restaurants", body, config);
      console.log(response.data);
      setAlert("Restaurant successfully created", "success");
      if (eventCtx?.returnTo) {
        clearCreationEventContext();
        navigate(eventCtx.returnTo);
        return;
      }
    } catch (err) {
      console.log(err.response);
      setAlert(
        err.response.data.errors
          ? err.response.data.errors[0].msg
          : "Error creating restaurant, please try again",
        "failure"
      );
      console.log(err.response.data.errors);
    }
    clearSuggestions();
    updateRestaurant(null);
  };
  if (currRestaurant === null) {
    return <Navigate to="/create/search" replace />;
  }
  return (
    <div className="row justify-content-right">
      <div className="col m-3 text-right">
        <div className="h3">Create a restaurant</div>
        <RestaurantEditForm
          currRestaurant={currRestaurant}
          submitBackendCall={createRestaurant}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currRestaurant: state.restaurantBuilder.restaurant,
  token: state.auth.token,
});
export default connect(mapStateToProps, {
  setAlert,
  updateRestaurant,
  clearSuggestions,
})(RestaurantCreateBuild);
